import { RouterModule, Routes } from '@angular/router';
import { AppCustomPreloader } from './custom-preloader';
import { instanceAuthenticatedGuard } from './services/guards/instance.guard';
import { authenticationGuard } from './services/guards/authentication.guard';
import { rightsGuard } from './services/guards/rights.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/orders',
        pathMatch: 'full'
    },
    {
        path: 'instances',
        canActivate: [instanceAuthenticatedGuard],
        loadChildren: () => import('../instances/routes')
    },
    {
        path: 'auth',
        loadChildren: () => import('../auth/index').then(m => m.AuthModule)
    },
    {
        path: 'orders',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../orders/index').then(m => m.OrdersModule)
    },
    {
        path: 'catalogue',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../catalogue/index').then(m => m.CatalogueModule)
    },
    {
        path: 'invoices',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../invoices/index').then(m => m.InvoicesModule)
    },
    {
        path: 'company',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../company/routes')
    },
    {
        path: 'company/contactpersons',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../contact-person/index').then(m => m.ContactPersonModule)
    },
    {
        path: 'company/addresses',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../address/routes')
    },
    {
        path: 'company/projects',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../project/index').then(m => m.ProjectModule)
    },
    {
        path: 'company/users',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../user/routes')
    },
    {
        path: 'company/roles',
        canActivate: [rightsGuard],
        data: {right: 'MANAGE_ROLES_AND_USERS'},
        loadChildren: () => import('../roles/index').then(m => m.RolesModule)
    },
    {
        path: 'contact',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../contact/routes')
    },
    {
        path: 'contact/branches',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../branches/routes')
    },
    {
        path: 'profile',
        canActivate: [authenticationGuard],
        loadChildren: () => import('../profile/index').then(m => m.ProfileModule)
    },
    {
        path: '**',
        redirectTo: '/orders',
        pathMatch: 'full'
    }
];
export const routing = RouterModule.forRoot(routes, { preloadingStrategy: AppCustomPreloader });
